'use client'

import Link from 'next/link'

interface LinkType {
  label: string
  url: string
}

interface SubMenuItem {
  link: LinkType
  subMenuItems?: SubMenuItem[]
}

interface SubMenuProps {
  items: SubMenuItem[]
}

const SubMenu = ({ items }: SubMenuProps) => {
  return (
    <ul className="absolute top-full left-0 min-w-[250px] flex-col bg-background opacity-0 invisible scale-y-0 group-hover:opacity-100 group-hover:visible group-hover:scale-y-100 transition-all duration-700 origin-top z-[99] shadow-lg rounded-md border border-border">
      {items?.map((item, idx) => (
        <li className="relative border-b border-border/20 w-full group/link" key={idx}>
          <Link
            href={item?.link?.url || '/'}
            className="block px-5 py-3 text-base text-foreground font-medium hover:bg-destructive hover:text-background transition duration-500"
          >
            {item?.link?.label}
          </Link>

          <ul className="absolute top-0 left-full min-w-[250px] flex-col bg-background opacity-0 invisible scale-y-0 group-hover/link:opacity-100 group-hover/link:visible group-hover/link:scale-y-100 transition-all duration-700 origin-top z-[99] shadow-lg rounded-md border border-border">
            {item?.subMenuItems?.map((subItem, subIdx) => (
              <li key={subIdx}>
                <Link
                  href={subItem?.link?.url || '/'}
                  className="block px-5 py-3 text-base text-foreground hover:bg-destructive hover:text-background transition duration-500"
                >
                  {subItem?.link?.label}
                </Link>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  )
}

export default SubMenu
